import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown, faAngleRight, faArrowDown, faArrowUp, faCheck, faDownload, faLock, faSearch, faTimes, faTrash, faUserCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faAngleDown, faAngleRight, faArrowDown, faArrowUp, faCheck, faDownload, faLock, faSearch, faTimes, faTrash, faUserCircle);
